import Dialog from "@base/Dialog/Dialog";

export default Dialog;
